module.exports = {"id":"f3767e8c-8af6-48ec-8d6f-8dcb8f781d95","name":"owner-compensation","items":[{"type":"inline","items":[{"name":"account","type":"text-field","props":{"label":"Chart of Account Affected","width":9,"required":true}},{"name":"amount","type":"text-field","props":{"label":"Amount","format":"dollars","width":3,"required":true}},{"name":"type","type":"selectlist","props":{"label":"Type of Compensation","items":"owner_compensation_types","required":true}},{"name":"notes","type":"textarea","props":{"label":"Notes","maxLength":250}}]}]}


//////////////////
// WEBPACK FOOTER
// ./src/components/valuation-elite/data_table_forms/owner-compensation.json
// module id = N2W3
// module chunks = 0